.Main {
    position: relative;
    padding: 0 var(--space);
    box-sizing: border-box;
}

.IsFixed {
    height: 100%;
}

.IsFixed .Inner {
    height: 100%;
}

.Fullscreen {
    min-height: 100vh;
}

.Fullscreen .Inner{
    min-height: 100vh;
}

.Inner {
    display: grid;
    overflow: hidden;
    padding: calc(var(--large-space) * 2) 0 0 0;
    grid-template: minmax(0, 1fr) / minmax(0, 1fr);
    grid-gap: var(--space) var(--small-space);
}

.NoPadding {
    padding: 0;
}

.Copy,
.Aside,
.Columns,
.Accordion,
.LinkList,
.Image,
.Embed,
.Video,
.Form,
.List {
    opacity: 0;
    transform: translateY(var(--space));
    transition: transform 750ms var(--ease-out-expo), opacity 750ms linear;
}

.Logo {
    width: 100%;
    height: 100%;
}

.IsVisible {
    opacity: 1;
    transform: none;
}

.IsFixed .Stickers {
    display: none;
}

@media (min-width: 768px) {
    .Main {
        padding: 0 var(--space);
    }

    .Inner {
        width: auto;
        display: grid;
        padding: var(--large-space) var(--space);
        grid-template: minmax(0, 1fr) / repeat(14, 1fr);
        grid-gap: var(--small-space) var(--small-space);
    }

    .IsSticky .Inner {
        position: sticky;
        top: 0;
    }

    .NoPadding {
        padding: 0;
    }

    .Logo {
        grid-column: span 14;
    }

    .Title {
        padding: 0;
        grid-column: span 14;
    }

    .Copy {
        padding: 0;
        grid-column: span 10;
    }

    .Aside {
        padding: 0;
        grid-column: span 5;
    }

    .Columns {
        padding: 0;
        grid-column: span 14;
    }

    .Accordion {
        padding: 0;
        grid-column: span 6;
    }

    .LinkList {
        padding: 0;
        grid-column: span 4;
    }

    .List {
        padding: 0;
        grid-column: span 5;
    }

    .Stickers {
        padding: 0;
        grid-column: span 14;
    }

    .Image {
        padding: 0;
        grid-column: span 14;
    }

    .Embed {
        padding: 0;
        grid-column: span 14;
    }

    .Video {
        padding: 0;
        grid-column: span 14;
    }

    .Form {
        padding: 0;
        grid-column: span 8;
    }
}

@media (min-width: 1440px) {
    .Inner {
        padding: var(--large-space) 6vw;
        grid-gap: var(--space) var(--small-space);
    }

    .NoPadding {
        padding: 0;
    }

    .Copy {
        padding: 0;
        grid-column: span 8;
    }
}